// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  ScheduleModalSidebarCoachFragmentDoc,
  ScheduleModalSidebarCoachingSessionFragmentDoc,
  ScheduleModalSidebarOrderFragmentDoc,
  ScheduleModalSidebarRecurringCadenceFragmentDoc,
} from './ScheduleModalSidebar.generated';
import { CancelCoachingSessionModalCoachingSessionFragmentDoc } from './CancelCoachingSessionModal.generated';
export type BaseScheduleModalLayoutCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  averageReviewRate: number;
  reviewTotal: number;
  newExperience?: boolean | null;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  hourlyRate?: number | null;
  tier: Types.SkuTier;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
  };
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
  } | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
};

export type BaseScheduleModalLayoutOneOnOneSessionFragment = {
  __typename?: 'OneOnOneSession';
  title: string;
};

export type BaseScheduleModalLayoutCoachingSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  startAt: number;
  endAt: number;
  durationInMinute: number;
  content:
    | {
        __typename: 'BootcampSession';
        bootcamp: { __typename?: 'Bootcamp'; id: string; title: string };
      }
    | { __typename: 'Class'; id: string; name?: string | null }
    | {
        __typename: 'OneOnOneSession';
        title: string;
        introOrder?: {
          __typename?: 'Order';
          introCall?: {
            __typename?: 'IntroCall';
            packages?: Array<{
              __typename?: 'OfferingPackage';
              id: string;
            }> | null;
          } | null;
        } | null;
      };
  coach: {
    __typename?: 'Coach';
    id: string;
    user: { __typename?: 'User'; id: string; firstName: string };
  };
  recurringSession?: { __typename?: 'RecurringSession'; id: string } | null;
};

export type BaseScheduleModalLayoutOrderFragment = {
  __typename?: 'Order';
  id: string;
  finalAmount?: number | null;
  hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
};

export type BaseScheduleModalLayoutRecurringCadenceFragment = {
  __typename?: 'RecurringCadence';
  type: Types.RecurrenceType;
  startHour: number;
  startMinute: number;
  durationMinutes: number;
  dayOfWeek?: Types.DayOfWeek | null;
  weekOfMonth?: number | null;
  interval?: number | null;
  isLastWeekOfMonth?: boolean | null;
};

export const BaseScheduleModalLayoutCoachFragmentDoc = gql`
  fragment BaseScheduleModalLayout_Coach on Coach {
    id
    slug
    averageReviewRate
    reviewTotal
    user {
      id
    }
    coachingTimeSummary {
      availableTime
      hasUnlimitedPackage
    }
    ...ScheduleModalSidebar_Coach
  }
  ${ScheduleModalSidebarCoachFragmentDoc}
`;
export const BaseScheduleModalLayoutOneOnOneSessionFragmentDoc = gql`
  fragment BaseScheduleModalLayout_OneOnOneSession on OneOnOneSession {
    title
  }
`;
export const BaseScheduleModalLayoutCoachingSessionFragmentDoc = gql`
  fragment BaseScheduleModalLayout_CoachingSession on CoachingSession {
    id
    startAt
    endAt
    content {
      ...BaseScheduleModalLayout_OneOnOneSession
    }
    ...CancelCoachingSessionModal_CoachingSession
    ...ScheduleModalSidebar_CoachingSession
  }
  ${BaseScheduleModalLayoutOneOnOneSessionFragmentDoc}
  ${CancelCoachingSessionModalCoachingSessionFragmentDoc}
  ${ScheduleModalSidebarCoachingSessionFragmentDoc}
`;
export const BaseScheduleModalLayoutOrderFragmentDoc = gql`
  fragment BaseScheduleModalLayout_Order on Order {
    id
    ...ScheduleModalSidebar_Order
  }
  ${ScheduleModalSidebarOrderFragmentDoc}
`;
export const BaseScheduleModalLayoutRecurringCadenceFragmentDoc = gql`
  fragment BaseScheduleModalLayout_RecurringCadence on RecurringCadence {
    ...ScheduleModalSidebar_RecurringCadence
  }
  ${ScheduleModalSidebarRecurringCadenceFragmentDoc}
`;
